import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Inject, OnInit } from '@angular/core';
import { PlaceholderChildComponent } from '@ispm/layout/classes/placeholder-child-component.abstract';
import * as _ from 'lodash';
import { PdfService } from '@ispm/test/services/pdf.service';
import { WorkflowService } from '@ispm/workflow/services/workflow.service';
import { NotificationMessageService } from '@ispm/core/components/customise-notification/notifications-message.service';

@Component({
  selector: 'ispm-model-approval',
  templateUrl: './model-approval.component.html',
  styleUrls: ['./model-approval.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ModelApprovalComponent extends PlaceholderChildComponent<any> implements OnInit {

  data: any;
  refId: string;

  constructor(private workflowService: WorkflowService, private pdfService: PdfService,
              private notificationMessageService: NotificationMessageService, private detector: ChangeDetectorRef) {
    super();
  }

  beforeClose() { }

  ngOnInit() {
    this.data = _.cloneDeep(this.payload.data);
    this.refId =  this.data && this.data.approvalDocument && this.data.approvalDocument.referenceId
      ? this.data.approvalDocument.referenceId
      : '';


  }

  formChanged(data, form) {
    this.data = form;
    this.refId = form.approvalDocument && form.approvalDocument.referenceId ? form.approvalDocument.referenceId : '';
  }

  downloadApprovalPdf($event) {
    if (this.refId) {
      return this.workflowService.getReportData(this.refId)
        .subscribe(result => {
          this.pdfService.downloadPDF(result, $event, this.refId);
          this.detector.markForCheck();
        },err=>{
          this.notificationMessageService.error('Error while getting PDF ' + $event + 'from server');
        }).add( () => {
            this.detector.markForCheck();
          });
    }
  }
}
